import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { ERROR_MESSAGES_MAP, ERROR_MESSAGE_MAP_TOKEN } from './data/error-messages.map';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    { provide: ERROR_MESSAGE_MAP_TOKEN, useValue: ERROR_MESSAGES_MAP },
  ]
};
